import * as CryptoJS from 'crypto-js';

/* -------------------------------------------------------------------------- */
/*                                   Crypto                                   */
/* -------------------------------------------------------------------------- */

export const encryptAES = (
	text: string,
	secretPassphrase: string
) => {
	return CryptoJS.AES.encrypt(
		text,
		secretPassphrase
	).toString();
};

export const decryptAES = (
	encryptedBase64: string,
	secretPassphrase: string
) => {
	const decrypted = CryptoJS.AES.decrypt(
		encryptedBase64,
		secretPassphrase
	);
	if (decrypted) {
		try {
			const str = decrypted.toString(CryptoJS.enc.Utf8);
			if (str.length > 0) {
				return str;
			} else {
				return false;
			}
		} catch (e) {
			return false;
		}
	}
	return false;
};

export const encryptAndStore = (
	text: string,
	secretPassphrase: string,
	storageKey: string
) => {
	const encryptedText = encryptAES(
		text,
		secretPassphrase
	);
	localStorage.setItem(storageKey, encryptedText);
};

export const decryptFromStorage = (
	storageKey: string,
	secretPassphrase: string
) => {
	const encryptedText = localStorage.getItem(storageKey);
	if (encryptedText) {
		return decryptAES(encryptedText, secretPassphrase);
	} else {
		return null;
	}
};
